import { Injectable, LOCALE_ID, inject } from '@angular/core';
import { MatDateFormats, NativeDateAdapter } from '@angular/material/core';
@Injectable()
export class AppDateAdapter extends NativeDateAdapter {
    constructor() {
        const locale = inject(LOCALE_ID);

        super(locale);
    }
}
export const APP_DATE_FORMATS: MatDateFormats = {
    parse: {
        dateInput: 'MM/DD/YYYY'
    },
    display: {
        dateInput: 'input',
        monthYearLabel: { year: 'numeric', month: 'numeric' },
        dateA11yLabel: { year: 'numeric', month: 'long', day: 'numeric' },
        monthYearA11yLabel: { year: 'numeric', month: 'long' }
    }
};
